import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { countCellsSelected } from 'modules/shift_management/hooks/useCountCellsSelected'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import {
  useSelectionDispatch,
  useSelectionState,
} from 'modules/shift_management/hooks/useSelection'
import { ADD_SHIFT_OPTIONS } from 'modules/shift_management/lib/addShiftOptions'
import { trackAddShiftStartEvent } from 'modules/shift_management/lib/trackEvents'
import { ShiftsRow } from 'modules/shift_management/lib/types'

import AddButton from './AddButton'
import AddShiftSidepanel from './AddShiftSidepanel'
import QuickActionsPopover from './QuickActionsPopover'

interface Props {
  shiftsRow: ShiftsRow
  date: moment.Moment
  contractVersions: ContractVersions
}

const AddShiftContextualButton = ({ shiftsRow, date, contractVersions }: Props) => {
  const [openAddShiftSidepanel, setOpenAddShiftSidepanel] = React.useState<boolean>(false)
  const [{ view }] = useSchedule()
  const { daysByRow, shifts, restDays } = useSelectionState()

  const dispatchSelection = useSelectionDispatch()

  const onCloseShiftSidepanel = () => {
    setOpenAddShiftSidepanel(false)
  }

  const onOpenAddShiftSidepanel = () => {
    const selectedEmployees = Object.keys(daysByRow).length
    const impactedEmployees = selectedEmployees || 1

    const cellCount = countCellsSelected({ daysByRow, shifts, restDays, view })
    const impactedShifts = cellCount || 1
    // Forcing to enable the day if it's not selected.
    dispatchSelection({
      type: 'TOGGLE_DAY',
      day: date,
      shiftsRow,
      view,
      forcedValue: true,
    })
    trackAddShiftStartEvent({
      view,
      impactedEmployees,
      cellCount: impactedShifts,
      shiftType: ADD_SHIFT_OPTIONS.savedCustom,
      from: 'contextual_button',
    })
    setOpenAddShiftSidepanel(true)
  }

  // We will not show quick actions and open the side panel directly
  if (view.isByAreas) {
    return (
      // Stop propagation to avoid unselecting the cell on the background.
      <Box onClick={(ev) => ev.stopPropagation()}>
        <AddButton onClick={onOpenAddShiftSidepanel} />
        {openAddShiftSidepanel && (
          <AddShiftSidepanel
            onClose={onCloseShiftSidepanel}
            date={date}
            contractVersions={contractVersions}
          />
        )}
      </Box>
    )
  }

  return (
    <QuickActionsPopover date={date} shiftsRow={shiftsRow} contractVersions={contractVersions} />
  )
}

export default observer(AddShiftContextualButton)
